import { REQUEST, LIST } from '../../../../redux/ActionType';
import { MY_JOB_APPLICATIONS } from '../../constants';

export const getMyJobApplications = (params) => ({
    type: REQUEST(LIST(MY_JOB_APPLICATIONS)),
    payload: { params },
});
